var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCowboy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 509.999 509.999",
    height: 512,
    viewBox: "0 0 509.999 509.999",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.404,
    x2: 295.797,
    y1: 453.554,
    y2: 576.914
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.635,
    x2: 338.348,
    xlinkHref: "#lg1",
    y1: 442.667,
    y2: 549.227
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.164,
    x2: 374.988,
    xlinkHref: "#lg1",
    y1: 493.813,
    y2: 625.362
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.459,
    x2: 340.638,
    y1: 345.771,
    y2: 487.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.408,
    x2: 199.633,
    xlinkHref: "#lg2",
    y1: 432.84,
    y2: 508.412
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.654,
    x2: 294.473,
    xlinkHref: "#lg2",
    y1: 409.497,
    y2: 488.098
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.549,
    x2: 324.715,
    xlinkHref: "#lg2",
    y1: 344.757,
    y2: 481.065
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.996,
    x2: 307.125,
    xlinkHref: "#lg2",
    y1: 445.095,
    y2: 502.511
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.819,
    x2: 303.956,
    xlinkHref: "#lg3",
    y1: 371.705,
    y2: 384.897
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.461,
    x2: 255.972,
    xlinkHref: "#lg4",
    y1: 411.878,
    y2: 362.974
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.41,
    x2: 151.784,
    xlinkHref: "#lg3",
    y1: 174.916,
    y2: 245.766
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.107,
    x2: 382.48,
    xlinkHref: "#lg3",
    y1: 174.916,
    y2: 245.766
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.086,
    x2: 371.145,
    xlinkHref: "#lg3",
    y1: 193.134,
    y2: 327.711
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.816,
    x2: 151.378,
    y1: 145.899,
    y2: -1.168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.666,
    x2: 259.717,
    xlinkHref: "#lg4",
    y1: 327.437,
    y2: 194.697
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 248.013,
    y2: 279.451
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.47,
    x2: 312.201,
    y1: 62.069,
    y2: 286.421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    stopColor: "#f0aa76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4808,
    stopColor: "#cf9362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#9b6d42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg1",
    y1: 327.15,
    y2: 187.083
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.126,
    x2: 510.785,
    xlinkHref: "#lg1",
    y1: 157.721,
    y2: 168.697
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.322,
    x2: 272.359,
    xlinkHref: "#lg1",
    y1: 206.185,
    y2: 90.221
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.743,
    x2: 414.793,
    y1: 67.554,
    y2: 148.781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6265,
    stopColor: "#b78154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.538,
    x2: 265.911,
    xlinkHref: "#lg1",
    y1: 10.443,
    y2: 66.628
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.585,
    x2: 189.19,
    xlinkHref: "#lg1",
    y1: 130.722,
    y2: 501.408
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.103,
    x2: 381.04,
    xlinkHref: "#lg1",
    y1: 93.001,
    y2: 299.593
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.572,
    x2: 310.76,
    xlinkHref: "#lg5",
    y1: 154.697,
    y2: 161.01
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.261,
    x2: 320.261,
    y1: 140.767,
    y2: 324.987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 331.848,
    y2: 314.375
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.205,
    x2: 285.149,
    xlinkHref: "#lg5",
    y1: 297.334,
    y2: 373.685
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.439 388.138h-200.879c-44.092 0-85.229 33.167-92.345 76.919l-5.892 36.228c-.78 4.797 2.512 8.714 7.359 8.714h382.636c4.847 0 7.878-5.524 7.099-10.308l-5.633-34.634c-7.116-43.752-48.254-76.919-92.345-76.919z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.999 509.999h191.318c4.847 0 7.878-5.524 7.099-10.308l-5.633-34.634c-7.116-43.752-48.254-76.919-92.345-76.919h-100.439z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.04 396.202h-187.935c-41.251 0-79.765 31.195-86.428 72.164l-5.454 33.535c-.725 4.459 2.333 8.098 6.834 8.098h354.771c4.847 0 8.23-3.917 7.56-8.714l-4.592-32.919c-5.713-40.969-43.505-72.164-84.756-72.164z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376.025 373.862-13.652-9.887v-8.832c0-7.451-6.699-14.033-16.527-16.238l-39.935-8.961c-33.163-7.442-68.66-7.442-101.823 0l-39.935 8.961c-9.827 2.205-16.526 8.787-16.526 16.238v8.832l-13.652 9.887c-5.729 4.149-8.083 10.138-6.271 15.857 7.435 23.463 34.696 92.943 122.546 119.588 3.034.92 6.465.92 9.499 0 87.85-26.645 115.112-96.125 122.546-119.588 1.813-5.719-.541-11.709-6.27-15.857zm-67.468-2.593c-13.227 19.946-37.061 34.02-47.907 39.702-3.373 1.767-7.926 1.767-11.3 0-10.846-5.682-34.68-19.756-47.907-39.702-6.018-9.075-3.724-19.976 6.16-27.056 8.83-6.325 23.493-12.286 47.397-12.286s38.567 5.961 47.397 12.286c9.884 7.079 12.178 17.98 6.16 27.056z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.024 373.861-13.651-9.885v-8.831c0-7.45-6.699-14.034-16.529-16.241l-35.627-7.995-4.307-.965c-33.166-7.44-68.657-7.44-101.823 0l-4.307.965-35.627 7.995c-9.83 2.208-16.529 8.792-16.529 16.241v8.831l-13.651 9.885c-1.148.832-2.167 1.742-3.035 2.708 10.93 28.939 41.13 86.574 119.309 110.285 3.035.921 6.466.921 9.501 0 78.179-23.711 108.379-81.347 119.309-110.285-.866-.965-1.885-1.876-3.033-2.708zm-67.468-2.594c-13.227 19.949-37.063 34.023-47.904 39.706-3.377 1.767-7.929 1.767-11.306 0-10.841-5.683-34.677-19.756-47.904-39.706-4.635-6.985-4.341-15.053.554-21.627 1.456-1.965 3.329-3.797 5.605-5.425 8.832-6.326 23.494-12.286 47.398-12.286s38.566 5.96 47.398 12.286c2.276 1.629 4.149 3.46 5.605 5.425 4.895 6.574 5.189 14.642.554 21.627z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.024 373.861-13.651-9.885v-8.831c0-7.45-6.699-14.034-16.529-16.241l-35.627-7.995-4.307-.965c-33.166-7.44-68.657-7.44-101.823 0l-4.307.965-35.627 7.995c-9.83 2.208-16.529 8.792-16.529 16.241v8.831l-13.651 9.885c-1.148.832-2.167 1.742-3.035 2.708 10.93 28.939 41.13 64.014 119.309 87.726 3.035.921 6.466.921 9.501 0 78.179-23.711 108.379-58.787 119.309-87.726-.866-.965-1.885-1.876-3.033-2.708zm-67.468-2.594c-13.227 19.949-37.063 34.023-47.904 39.706-3.377 1.767-7.929 1.767-11.306 0-10.841-5.683-34.677-19.756-47.904-39.706-4.635-6.985-4.341-15.053.554-21.627 1.456-1.965 3.329-3.797 5.605-5.425 8.832-6.326 23.494-12.286 47.398-12.286s38.566 5.96 47.398 12.286c2.276 1.629 4.149 3.46 5.605 5.425 4.895 6.574 5.189 14.642.554 21.627z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.373 363.976v-8.831c0-7.45-6.699-14.034-16.529-16.241l-39.934-8.96c-6.617-1.485-13.323-2.673-20.09-3.564-20.377-2.688-41.267-2.688-61.644 0-6.767.891-13.473 2.079-20.09 3.564l-39.934 8.96c-9.83 2.208-16.529 8.792-16.529 16.241v8.831l-.027.02c17.697 28.063 48.786 60.501 102.65 76.837 3.035.921 6.466.921 9.501 0 53.865-16.336 84.953-48.774 102.651-76.837zm-53.817 7.291c-13.227 19.949-37.063 34.023-47.904 39.706-3.377 1.767-7.929 1.767-11.306 0-10.841-5.683-34.677-19.756-47.904-39.706-6.015-9.074-3.726-19.974 6.159-27.053 5.94-4.252 14.512-8.341 26.755-10.559 5.968-1.089 12.81-1.728 20.644-1.728s14.676.639 20.643 1.728c12.243 2.218 20.815 6.307 26.755 10.559 9.884 7.079 12.174 17.979 6.158 27.053z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376.025 373.862-13.652-9.887v-8.832c0-7.451-6.699-14.033-16.526-16.238l-4.685-1.051c.468 1.341.717 2.738.717 4.168v8.832l13.652 9.887c5.729 4.149 8.083 10.138 6.271 15.857-6.248 19.718-26.499 71.935-84.944 103.916-24.988 13.673-59.593 13.712-84.594.051-.124-.068-.249-.136-.373-.204 15.62 11.581 34.8 21.798 58.335 28.939 3.042.923 6.482.93 9.524.007 87.85-26.645 115.111-96.125 122.546-119.588 1.812-5.719-.542-11.709-6.271-15.857z",
    fill: "url(#SVGID_8_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m311.858 352.029v8.763c0 3.553-1.088 7.136-3.303 10.48-12.925 19.482-35.97 33.365-47.138 39.293-.259.14-.519.28-.768.409-3.373 1.767-7.924 1.767-11.298 0-10.849-5.689-34.682-19.761-47.906-39.702-2.216-3.344-3.304-6.926-3.304-10.48v-8.763z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.858 352.029v8.763c0 3.553-1.088 7.136-3.303 10.48-12.925 19.482-35.97 33.365-47.138 39.293l-62.847-53.595-.429-.369v-4.571h113.717z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 139.651,
    cy: 214.364,
    fill: "url(#SVGID_11_)",
    r: 34.083
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.348,
    cy: 214.364,
    fill: "url(#SVGID_12_)",
    r: 34.083
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 367.232c-63.898 0-115.698-51.8-115.698-115.698v-121.724c0-63.898 51.8-115.698 115.698-115.698 63.898 0 115.698 51.8 115.698 115.698v121.724c-.001 63.898-51.8 115.698-115.698 115.698z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 353.451c-58.911 0-106.668-47.757-106.668-106.668v-112.223c0-58.911 47.757-106.668 106.668-106.668 58.911 0 106.668 47.757 106.668 106.668v112.223c-.001 58.911-47.758 106.668-106.668 106.668z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.968 364.304c51.394-11.786 89.729-57.801 89.729-112.77v-121.724c0-63.898-51.8-115.698-115.698-115.698-63.898 0-115.698 51.8-115.698 115.698v92.828z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.572 284.442h-13.145c-10.535 0-18.742-9.137-17.615-19.611l6.873-63.889h34.629l6.873 63.889c1.127 10.474-7.08 19.611-17.615 19.611z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464.048 69.565c-21.353-13.466-61.42 10.173-81.959 17.532-41.108 14.728-83.712 24.081-127.078 24.081-43.371 0-85.967-9.351-127.078-24.081-20.283-7.267-60.686-31.13-81.96-17.532-29.538 18.881 5.339 75.294 19.007 92.787 44.789 57.321 119.11 86.236 190.031 86.236 70.919 0 145.243-28.916 190.03-86.236 13.709-17.544 48.474-74.204 19.007-92.787z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.042 153.343c-44.787 57.32-119.111 86.236-190.03 86.236-70.921 0-145.242-28.915-190.031-86.237-9.193-11.765-27.98-41.138-30.309-64.855-2.774 24.698 19.907 60.552 30.309 73.865 44.788 57.321 119.11 86.236 190.031 86.236 70.919 0 145.243-28.916 190.03-86.236 10.433-13.352 33.055-49.357 30.284-73.994-2.326 23.701-21.066 53.187-30.284 64.985z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.049 69.565c-8.186-5.162-19.124-4.868-30.656-2.132 2.413 24.622-19.974 60.231-30.336 73.493-44.788 57.32-119.111 86.236-190.03 86.236-32.52 0-65.748-6.098-96.523-18.209 40.916 26.358 90.486 39.634 138.509 39.634 70.919 0 145.243-28.916 190.03-86.236 13.707-17.543 48.472-74.203 19.006-92.786z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m464.858 130.16c-6.565 13.519-14.67 25.609-19.817 32.191-44.788 57.326-119.106 86.242-190.034 86.242-12.741 0-25.594-.931-38.361-2.8l-84.023-82.181c-6.928-5.88-9.843-15.262-7.153-24.061l17.865-47.218c37.28 12.267 72.619 18.843 111.673 18.843 43.37 0 85.969-9.348 127.081-24.077 10.12-3.621 24.98-11.201 40.005-16.345 15.474-5.296 31.122-8.02 41.951-1.185 18.415 11.607 11.755 38.078.813 60.591z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.519 2.635-3.312 1.359c-23.161 9.503-49.255 9.503-72.416 0l-3.312-1.359c-18.865-7.74-40.429 2.22-46.303 21.387l-43.706 115.532c-3.03 9.889 1.024 20.543 9.927 26.089l12.097 7.535c65.585 40.85 149.425 40.85 215.01 0l12.097-7.535c8.903-5.545 12.957-16.2 9.927-26.089l-43.706-115.532c-5.874-19.167-27.438-29.127-46.303-21.387z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.381 7.514c0-2.546-.417-5.029-1.2-7.425-5.173-.35-10.517.436-15.662 2.547l-3.312 1.359c-23.161 9.503-49.255 9.503-72.416 0l-3.312-1.359c-5.145-2.111-10.489-2.896-15.662-2.547-.783 2.397-1.201 4.88-1.201 7.425 0 19.931 25.243 36.089 56.382 36.089s56.383-16.158 56.383-36.089z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.504 173.178 12.097-7.535c8.903-5.545 12.957-16.2 9.927-26.089l-43.706-115.532c-5.873-19.167-27.437-29.128-46.303-21.387l-3.312 1.359c-11.581 4.751-23.894 7.127-36.208 7.127v192.694c37.356 0 74.713-10.212 107.505-30.637z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.528 139.554-43.706-115.532c-5.229-17.063-22.892-26.817-40.016-23.295.047.146.101.287.146.434l31.512 75.469c10.947 35.633-6.403 73.918-40.963 89.468-.689.31-1.304.572-1.837.781-50.524 19.835-107.399 18.7-157.198-3.402.909.784 1.883 1.513 2.93 2.165l12.097 7.535c65.585 40.85 149.425 40.85 215.011 0l12.097-7.535c8.903-5.544 12.957-16.199 9.927-26.088z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m378.613 120.253c-.508-1.657-2.49-2.334-3.981-1.403-.01.007-.021.013-.031.02l-12.097 7.535c-65.585 40.851-149.425 40.851-215.011 0l-12.097-7.535c-.01-.007-.021-.013-.031-.02-1.491-.932-3.473-.255-3.981 1.403l-5.914 19.301c-3.03 9.889 1.024 20.543 9.927 26.088l12.097 7.535c65.585 40.85 149.425 40.85 215.011 0l12.097-7.535c8.903-5.545 12.957-16.2 9.927-26.089z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.527 116.709c-.908.783-1.881 1.51-2.926 2.161l-12.097 7.535c-32.793 20.425-70.149 30.631-107.505 30.63v46.78c37.356 0 74.713-10.212 107.505-30.638l12.097-7.535c8.903-5.545 12.957-16.2 9.927-26.089z",
    fill: "url(#SVGID_26_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m279.691 334.204c-7.785 3.823-16.238 5.729-24.692 5.729-8.453 0-16.907-1.906-24.692-5.729-5.619-2.755-8.643-8.284-8.643-13.893 0-3.892 1.457-7.825 4.521-10.889 2.894-2.894 6.827-4.521 10.919-4.521h35.79c2.046 0 4.052.409 5.908 1.178 1.856.768 3.563 1.896 5.01 3.343 3.064 3.064 4.521 6.996 4.521 10.889.001 5.609-3.023 11.138-8.642 13.893z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.561 291.557c-4.671 3.872-9.162 6.707-13.354 8.773-12.625 6.248-27.746 4.531-38.924-4.052-5.429-4.172-11.467-7.385-17.865-9.551-6.397-2.176-13.144-3.304-19.981-3.304h-34.103c-13.324 0-26.069 4.761-36.638 12.875-11.168 8.573-26.278 10.27-38.904 4.032-4.192-2.066-8.683-4.9-13.354-8.773-2.625-2.176-6.427.429-5.32 3.653 7.465 21.558 30.58 67.308 96.471 91.042 9.971 3.593 20.849 3.593 30.82 0 65.891-23.733 89.006-69.484 96.471-91.042 1.108-3.224-2.695-5.828-5.319-3.653zm-81.87 42.647c-7.785 3.823-16.238 5.729-24.692 5.729-8.453 0-16.907-1.906-24.692-5.729-5.619-2.755-8.643-8.284-8.643-13.893 0-3.892 1.457-7.825 4.521-10.889 2.894-2.894 6.827-4.521 10.919-4.521h35.79c2.046 0 4.052.409 5.908 1.178 1.856.768 3.563 1.896 5.01 3.343 3.064 3.064 4.521 6.996 4.521 10.889.001 5.609-3.023 11.138-8.642 13.893z",
    fill: "url(#SVGID_28_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCowboy);
export default __webpack_public_path__ + "static/media/icon-cowboy.518061c82aa8eb4022e927233e84cacc.svg";
export { ForwardRef as ReactComponent };